import { render } from "./Entitlements.vue?vue&type=template&id=04d46966"
import script from "./Entitlements.vue?vue&type=script&lang=js"
export * from "./Entitlements.vue?vue&type=script&lang=js"

import "./Entitlements.vue?vue&type=style&index=0&id=04d46966&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__